import type { ReactNode } from 'react'
import {
  EmptyState,
  EmptyStateDescription,
  EmptyStateTitle,
} from '@/components/EmptyState'
import { IconButton } from '@/components/IconButton'
import styles from './TemplateEditor.module.css'

export interface TemplateEditorProps {
  /**
   * The template's name field.
   */
  nameInput: ReactNode
  /**
   * Shows a button that deletes the template.
   */
  onDelete?: () => unknown
  /**
   * The template's mappings.
   */
  children?: ReactNode
  isEmpty: boolean
  deleteTestId?: string
}

/**
 * A template: its name, and how it answers each question.
 */
export function TemplateEditor({
  nameInput,
  onDelete,
  children,
  isEmpty,
  deleteTestId,
}: TemplateEditorProps) {
  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <div className={styles.name}>{nameInput}</div>
        {onDelete && (
          <IconButton
            name="delete"
            label="Delete template"
            onPress={onDelete}
            testId={deleteTestId}
          />
        )}
      </div>
      <p className={styles.description}>
        Set requirements allowing for automated question mapping during scoping.
      </p>
      {children}
      {isEmpty && (
        <EmptyState size="sm">
          <EmptyStateTitle>No questions to map</EmptyStateTitle>
          <EmptyStateDescription>
            Add questions to the legend and they show up here.
          </EmptyStateDescription>
        </EmptyState>
      )}
    </div>
  )
}
